import { useState, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_SALE: 'sale_add',
  EDIT_SALE: 'sale_change',
  DELETE_SALE: 'sale_delete',
  VIEW_SALE: 'sale_view'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_SALE,
    PERMISSIONS.EDIT_SALE,
    PERMISSIONS.DELETE_SALE,
    PERMISSIONS.VIEW_SALE
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.CREATE_SALE,
    PERMISSIONS.EDIT_SALE,
    PERMISSIONS.DELETE_SALE,
    PERMISSIONS.VIEW_SALE
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_SALE,
    PERMISSIONS.VIEW_SALE
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.EDIT_SALE,
    PERMISSIONS.VIEW_SALE
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_SALE
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createSale: () => hasPermission(PERMISSIONS.CREATE_SALE),
    editSale: () => hasPermission(PERMISSIONS.EDIT_SALE),
    deleteSale: () => hasPermission(PERMISSIONS.DELETE_SALE),
    viewSale: () => hasPermission(PERMISSIONS.VIEW_SALE)
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
